<section *ngIf="updateProfileForm"
    class="row-container row-gap-1 height-auto overflow-hidden">
    <form class="vertical-container-simple width-100pcnt column-gap-1p25"
        [formGroup]="updateProfileForm">
        <div class="main main-padding vertical-container-simple column-gap-1">
            <div class="row-container row-gap-1">
                <app-upload #upload
                    data-qa="account-photo"
                    [oldImgSrc]="updateProfileForm?.value.photo"
                    [widthHeight]="'width-14 height-13p4'"
                    (deleteOldLink)="updateProfileForm.patchValue({ photo: undefined })">
                </app-upload>
                <div class="start-column-container column-gap-1">
                    <div class="font-2 bold600 align-self-start">Main information</div>
                    <div class="centered-row-container row-gap-1p5">
                        <app-input
                            data-qa="account-name"
                            formControlName="name"
                            class="width-18"
                            [title]="'First name'"
                            [additionalClass]="updateProfileForm.value.name.length ? '' : 'error'" >
                        </app-input>
                        <app-input
                            data-qa="account-secondName"
                            formControlName="secondName"
                            class="width-18"
                            [title]="'Last name'">
                        </app-input>
                        <app-input
                            data-qa="account-company"
                            formControlName="company"
                            class="width-18"
                            [title]="'Workplace'">
                        </app-input>
                        <app-input
                            data-qa="account-position"
                            formControlName="position"
                            class="width-18"
                            [title]="'Position'">
                        </app-input>
                </div>
                <div class="font-2 bold600 align-self-start">Contact</div>
                <div class="start-row-container row-gap-1p5  align-self-start">
                 <app-input
                    data-qa="account-email"
                    formControlName="email"
                    class="width-18"
                    [type]="'email'"
                    [title]="'Work email'"
                    [additionalClass]="'disabled'">
                </app-input>
                 <app-input
                    data-qa="account-linkedIn"
                    formControlName="linkedIn"
                    class="width-18"
                    [title]="'LinkedIn'">
                </app-input>
                </div>
                <app-button data-qa="edit-main-info-button"
                            [type]="'accent'"
                            [size]="'small'"
                            [disabled]="!updateProfileForm.value.name.length"
                            [additionalClasses]="'btn-width-5 text-align-center'"
                            (buttonClick)="updateProfile()">
                  Save
                </app-button>
                <div class="grey-line"></div>
                <div class="flex align-items-center row-gap-1">
                  <label class="font-2 bold600">Password</label>
                  <app-button
                    data-qa="show-modal-change-pwd-button"
                    [type]="'accent'"
                    [size]="'small'"
                    (buttonClick)="showModalChangePwd()"> Change
                  </app-button>
                </div>
                <div class="grey-line"></div>
                <!--CHANGE PHONE -->
                <div class="start-column-container align-self-stretch column-gap-1">
                    <div class="flex column-gap-0p25 font-2 bold600">Verification method (2FA)</div>
                    <div class="flex row-gap-1">
                      <div class="width-18">
                        <app-selector
                          data-qa="change-verification-method-selector"
                          class="width-18"
                          [title]="'Verification type'"
                          [data]="verificationMethodsValues"
                          [selectedItem]="verificationMethods[profile.verificationMethod]"
                          [isNotInTable]="true"
                          (itemEmitter)="changeVerificationMethod($event)">
                        </app-selector>
                      </div>
                      <app-input
                           data-qa="editPhone-input"
                           formControlName="phone"
                           class="width-18 flex"
                           [title]="'Phone number'"
                           [additionalClass]="show.errorPhoneInput ? 'error' : ''"
                           [bottomText]="show.errorPhoneInput ? 'Phone number not valid' : ''"
                           (inputChange)="editPhone($event)">
                      </app-input>
                      <app-input
                        *ngIf="show.codeInput"
                         data-qa="input-for-twilio-code"
                         formControlName="verificationCode"
                         class="width-18"
                         [title]="'Enter verification code'"
                         [additionalClass]="show.errorCodeInput ? 'error' : ''"
                         [bottomText]="show.errorCodeInput ? 'Verification code not valid' : ''"
                         (inputChange)="enterVerificationCode()">
                      </app-input>
                      <app-button
                          *ngIf="show.sendCodeButton"
                          data-qa="send-Twilio-code-button"
                          class="align-self-end"
                          [type]="'accent'"
                          [class.mb-2p5]="show.errorPhoneInput"
                          (buttonClick)="sendVerificationCode()">
                        Send verification code
                      </app-button>
                      <div *ngIf="show?.description"
                           class="flex row-gap-1 height-2p5"
                           [ngClass]="show.errorCodeInput ? 'align-self-center': 'align-self-end'" >
                        <div class="main-8-vertical-line"></div>
                        <div class="font-4 centered-row-container width-16">{{ numberDescription }}</div>
                      </div>
                      <div *ngIf="show.timer"
                           class="font-4 flex row-gap-1 height-2p5"
                           [ngClass]="show.errorCodeInput ? 'align-self-center': 'align-self-end'">
                        <div class="main-8-vertical-line"></div>
                        <div class="width-10">Code sent. Resend code in {{ counter.countdownSeconds }} seconds</div>
                      </div>
                    </div>
                    <app-button
                        *ngIf="show.codeInput"
                        data-qa="submit-changed-phone-button"
                        [type]="'accent'"
                        [disabled]="!(updateProfileForm.value.verificationCode.length === 6)"
                        (buttonClick)="submitVerificationCode()">
                      Update verification method
                    </app-button>
                </div>
            </div>
        </div>
      </div>
    </form>

    <app-modal-change-password *ngIf="show.changePwdModal"
                               [email]="profile?.email"
                               (closeEmitter)="hideModalChangePwd()">
    </app-modal-change-password>
</section>
